<template>
  <div :class="'col-sm-12 col-md-' + item.cols">
    <span class="text-secondary item-title text-muted" v-if="showOpt"><small>{{ item.title }}</small></span>
    <el-date-picker v-if="item.type === 'datepicker'" v-model="selecteddate" type="date" :id="item.id"
      :required="item.isRequired" format="yyyy-MM-dd">
    </el-date-picker>
    <input v-if="item.type === 'hidden'" type="hidden" :id="item.id" />
    <div class="input-group input-group-sm" v-if="item.type === 'textbox' && showOpt">
      <div class="input-group-prepend" v-if="item.prefix !== ''">
        <span class="input-group-text">{{ item.prefix }}</span>
      </div>
      <input type=text class="form-control form-control-sm" :id="item.id" :required="item.isRequired"
        :disabled="item.readonly === 'always'" :maxlength="item.maxlength" :pattern="item.pattern" v-model="item.val" />
      <div class="input-group-prepend" v-if="item.suffix !== ''">
        <span class="input-group-text">{{ item.suffix }}</span>
      </div>
    </div>
    <div class="form-group form-check" v-if="item.type === 'checkbox'">
      <input type="checkbox" class="form-check-input" :id="item.id" />
      <label class="form-check-label" :for="item.id">{{ item.title }}</label>
    </div>
    <div class="form-inline" v-if="item.type === 'search'">
      <div class="input-group input-group-sm">
        <div class="input-group-prepend" v-if="item.prefix !== ''">
          <span class="input-group-text">{{ item.prefix }}</span>
        </div>
        <input type=text class="form-control form-control-sm " @blur="getTxtByVal(item.val)" :id="item.id"
          :required="item.isRequired" :disabled="item.readonly === 'always'" :maxlength="item.maxlength"
          :pattern="item.pattern" v-model="item.val" />
        <div class="input-group-prepend" v-if="item.suffix !== ''">
          <span class="input-group-text btn">{{ this.$t('lang.toolbar.Select') }}</span>
        </div>
      </div>
      <label :for="item.id" class="col-form-label-sm text-muted selectedlabel">{{ item.txt }}</label>
    </div>
    <div v-if="item.type === 'paragraphs'">
      <div class="accordion accordion-flush" id="accordionFlushParagraphs">
        <div class="accordion-item" v-for="(paragraph, idx) in item.paragraphs" :key="paragraph.id">
          <h2 class="accordion-header" :id="'flush-heading' + idx">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
              :data-bs-target="'#flush-collapse' + idx" aria-expanded="false" :aria-controls="'flush-collapse' + idx">
              {{ paragraph.order }}# {{ paragraph.title }}
            </button>
          </h2>
          <div :id="'flush-collapse' + idx" class="accordion-collapse collapse" :aria-labelledby="'flush-heading' + idx"
            data-bs-parent="#accordionFlushParagraphs">
            <div class="accordion-body px-2">
              <div :id="paragraph.id" class="alert alert-secondary alert-dismissible fade show paragraph" role="alert">
                <div class="row input-group">
                  <div class="col-auto ">
                    <input type=text class="form-control form-control-sm" v-if="item.showOrder"
                      :required="item.isRequired" :placeholder="$t('lang.dict.order')" :maxlength="item.maxlength"
                      v-model="paragraph.order" />
                  </div>
                  <div class="col-auto">
                    <input type=text class="form-control form-control-sm" v-if="item.showTitle"
                      :required="item.isRequired" :placeholder="$t('lang.dict.title')" :maxlength="item.maxlength"
                      v-model="paragraph.title" />
                  </div>
                  <div class="col-auto">
                    <span class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#myModalAlbum"
                      :data-bs-fileList="paragraph.fileList" :data-bs-paragraphid="paragraph.id">
                      {{ $t('lang.dict.showGallery') }}
                    </span>
                  </div>
                </div>
                <el-input type="textarea" :autosize="{ minRows: 2 }" v-if="item.showBody" :required="item.isRequired"
                  :placeholder="$t('lang.dict.body')" :maxlength="item.maxlength" v-model="paragraph.body"></el-input>
                <button type="button" class="btn-close" v-on:click="delParagraph(paragraph.id, paragraph)"
                  aria-label="Close" data-toggle="modal" :data-metakey="paragraph.id">
                </button>
                <div class="d-flex row">
                  <div class="col-md-2 col-sm-6" v-for="pfile in paragraph.fileList" :key="pfile">
                    <el-image class="img-fluid" :src="pfile" fit="cover"></el-image>
                  </div>
                </div>
                <div v-for="part in paragraph.parts" :key="part.id">
                  <div :id="part.id" class="alert alert-info alert-dismissible fade show part" role="alert">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" type="checkbox" :name="'partTypeCheck' + part.id"
                        :disabled="part.code != '' && part.code != null" :id="'inlineCheck2' + part.id"
                        v-model="part.showCode">
                      <label class="form-check-label" :for="'inlineCheck2' + part.id">{{ $t('lang.dict.code') }}</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <span class="btn btn-sm btn-outline-primary" data-bs-toggle="modal" data-bs-target="#myModalAlbum"
                        :data-bs-fileList="part.fileList" :data-bs-paragraphid="paragraph.id" :data-bs-partid="part.id">
                        {{ $t('lang.dict.showGallery') }}
                      </span>
                    </div>
                    <input type=text class="form-control form-control-sm" :placeholder="$t('lang.dict.title')"
                      v-model="part.title" />
                    <el-input type="textarea" :autosize="{ minRows: 2 }" :placeholder="$t('lang.dict.body')"
                      v-model="part.body"></el-input>
                    <el-input type="textarea" :autosize="{ minRows: 2 }" v-if="part.showCode"
                      :placeholder="$t('lang.dict.code')" v-model="part.code"></el-input>
                    <div class="d-flex row">
                      <div class="col-md-2 col-sm-6" v-for="file in part.fileList" :key="file">
                        <el-image :src="file" fit="cover"></el-image>
                      </div>
                    </div>
                    <button type="button" class="btn-close" v-on:click="delPart(part.id, paragraph, part)"
                      aria-label="Close" data-toggle="myModalConfirm" :data-metakey="part.id" data-whatever="delPart">
                    </button>
                  </div>
                </div>
                <div class="float-end">
                  <a href="#" class="card-link part" v-on:click.prevent="addPart(idx, paragraph, paragraph.id)">{{
    $t('lang.toolbar.AddPart') }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a href="#" class="float-end card-link" v-on:click.prevent="addParagraph(item.id)">{{
    this.$t('lang.toolbar.AddParagraph')
  }}</a>
    </div>
    <el-input type="textarea" :autosize="{ minRows: 2 }" v-if="item.type === 'textarea' && showOpt" :id="item.id"
      :required="item.isRequired" :maxlength="item.maxlength" :pattern="item.pattern" v-model="item.val"></el-input>
    <vue-tags-input v-if="item.type === 'tagsinput'" v-model="tag" :tags="tags" :autocomplete-items="item.opts"
      :add-only-from-autocomplete="true" @tags-changed="newTags => tags = newTags">
    </vue-tags-input>
    <input v-if="item.type === 'tagsinput'" v-model="tagval" type="hidden" :id="item.id" />
    <label v-if="item.type === 'label'" class=" col-form-label col-form-label-sm">{{ item.val }}</label>
    <select v-if="item.type === 'select'" class="form-control form-control-sm" :id="item.id"
      :disabled="item.readonly === 'always'" :required="item.isRequired" v-model="item.val">
      <option value="">{{ item.placeholder }}...</option>
      <option v-for="opt in item.opts" :value="opt.val" :key="opt.val">{{ opt.txt }}</option>
    </select>
    <div class="invalid-tooltip">{{ item.invalidTooltip }}</div>
  </div>
</template>

<script>
import $ from "jquery";
import VueTagsInput from '@johmun/vue-tags-input';
import sx from "../utils/core.js";
import { Alert } from 'bootstrap'

export default {
  components: {
    VueTagsInput
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      selecteddate: '',
      tag: '',
      tags: [],
      tagval: '',
      mstdata: []
    };
  },
  watch: {
    tags: function (newVal) {
      console.log(newVal)
      const that = this
      var list = []
      $.each(newVal, function (index, item) {
        list.push(item.text)
      });
      that.tagval = list.join(",");
      that.item.tag = that.tagval;
      that.item.tagcode = sx.tagsName2Code(that.tagval, that.item.optlist);
    },
    '$store.state.tag': function (newVal) {
      console.log(newVal)
      const that = this
      if (!sx.isNothingOrEmpty(newVal)) {
        var tvlist = newVal.split(",")
        that.tags = []
        $.each(tvlist, function (index, item) {
          that.tags.push({ text: item })
        });
      }
    },
    'item.tag': function (newVal) {
      console.log(newVal)
      const that = this
      if (!sx.isNothingOrEmpty(newVal)) {
        var tvlist = newVal.split(",")
        that.tags = []
        $.each(tvlist, function (index, item) {
          that.tags.push({ text: item })
        });
      } else {
        that.tags = []
      }
    }
  },
  props: {
    item: {
      id: String,
      type: Object,
      title: String,
      invalidTooltip: String,
      placeholder: String,
      tag: String,
      tagcode: String,
      cols: Number,
      maxlength: Number,
      pattern: String,
      isRequired: true,
      paragraphs: []
    }
  },
  mounted() {
    const that = this
    if (that.item.type === 'datepicker') {
      that.selecteddate = that.item.val
    } else if (that.item.type === 'checkbox') {
      if (that.item.val == '1') {
        $("#" + that.item.id).prop("checked", true);
      } else {
        $("#" + that.item.id).prop("checked", false);
      }
    } else if (that.item.type === 'tagsinput') {
      that.getTags(that.item.tag);
    }

    $("#myModalConfirm").on("show.bs.modal", function (event) {
      console.log(event)
      var button = $(event.relatedTarget); // Button that triggered the modal
      var eventid = button.data("whatever"); // Extract info from data-* attributes
      if (eventid === "delParagraph") {
        that.$store.state.confirmdef = {
          title: that.$t('lang.toolbar.Confirm'),
          msg: that.$t('lang.msg.toDelete'),
          event: 'delParagraph'
        }
        that.$store.state.metakey = button.data("metakey");// delete target metakey
      }
    });
    $("#confirm").click(function () {
      if (that.$store.state.confirmdef.event !== "delParagraph") {
        return;
      }
      $("#" + that.$store.state.metakey).alert('close');
      $("#myModalConfirm").modal("hide");
      that.delParagraph(that.$store.state.metakey);
    });
  },
  computed: {
    showOpt: function () {
      if (this.item.show == null) {
        return true
      } else {
        return this.item.show
      }
    }
  },
  methods: {
    getTags(val) {
      const that = this
      if (!sx.isNothingOrEmpty(val)) {
        var tvlist = val.split(",")
        that.tags = []
        $.each(tvlist, function (index, item) {
          that.tags.push({ text: item })
        });
      } else {
        that.tags = []
      }
    },
    getTxtByVal(val) {
      const that = this;
      const mymodal = sx.showWaiting()
      var params = {
        bucketid: '13',
        mst: that.item.mst,
        options: JSON.stringify(that.item.mstoptions),
        token: localStorage.getItem("token") || "token"
      }
      var url = that.$store.state.baseurl + '/app/authhelper/fetchMstList'
      that.mstdata = []
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === 'ok') {
            that.mstdata = result.data.rows
            if (val) {
              $.each(that.mstdata, function (index, row) {
                if (val == row[0]) {
                  that.item.txt = row[1]
                }
              });
            }
            sx.hideWaiting(mymodal)
          } else {
            sx.toastSuccess(result.message)
            console.log(result.message)
            sx.hideWaiting(mymodal)
          }
        },
        function () {
          sx.login(
            url,
            params,
            function (result) {
              if (result.status === 'ok') {
                that.mstdata = result.data.rows
                if (val) {
                  $.each(that.mstdata, function (index, row) {
                    if (val == row[0]) {
                      that.item.txt = row[1]
                    }
                  });
                }
                sx.hideWaiting(mymodal)
              } else {
                sx.toastError(that.$t('lang.error.failedRequest', { err: result.message }));
              }
            }
          )
        }
      )
      sx.hideWaiting(mymodal)
    },
    addParagraph: function (id) {
      const that = this;
      console.log(id)
      that.item.seq = that.item.seq + 1;

      that.item.paragraphs.push({
        id: id + that.item.seq,
        ord: that.item.seq,
        showGallery: false,
        title: "",
        body: "",
        fileList: [],
        parts: []
      })
    },
    delParagraph: function (key, paragraph) {
      const that = this;
      console.log(key)
      const alert = Alert.getOrCreateInstance("#" + key)
      alert.close()
      var idx = that.item.paragraphs.indexOf(paragraph)
      that.item.paragraphs.splice(idx, 1);
    },
    addPart: function (idx, paragraph, id) {
      console.log(id)
      if (sx.isNothingOrEmpty(paragraph.seq)) {
        paragraph.parts = [];
        paragraph.seq = 0;
      }
      paragraph.seq = paragraph.seq + 1;
      paragraph.parts.push({
        id: id + "_" + paragraph.seq,
        ord: paragraph.seq,
        code: "",
        body: "",
        fileList: []
      })
    },
    delPart: function (key, paragraph, part) {
      console.log(key)
      const alert = Alert.getOrCreateInstance("#" + key)
      alert.close()
      var idx = paragraph.parts.indexOf(part)
      paragraph.parts.splice(idx, 1);
    }
  }
};
</script>

<style>
.alert {
  padding: 0.6rem 0.6rem
}

.alert-dismissible {
  padding-right: 1.2rem;
}

.alert-dismissible .btn-close {
  padding: 0.6rem 0.6rem
}

.part {
  font-size: 10pt
}

.card-link:hover {
  color: #FF9933 !important;
}

.col-form-label-sm {
  padding-top: calc(0.45rem + 1px);
  padding-bottom: calc(0.15rem + 1px);
  line-height: 1.4;
}

label {
  margin-bottom: 0.1rem;
}

.selectedlabel {
  margin-left: 20px;
}

.paragraph {
  padding-bottom: 1.6rem
}

.paragraph input {
  margin-bottom: 2px
}

.el-date-editor {
  display: block;
  margin-bottom: 6px;
}

.el-input__inner {
  display: block;
  height: 30px;
  line-height: 30px;
}

.el-input__icon {
  line-height: 30px;
}

.el-upload--picture-card .el-upload-list__item-actions {
  width: 124px;
  height: 124px;
  line-height: 122px;
}

.input-group {
  margin-right: 2px;
  margin-bottom: 6px;
}

.form-check-inline {
  margin-top: 4px;
}

.form-inline {
  margin-bottom: 2px;
  margin-top: 2px;
}

.item-title {
  color: lightgray;
  padding-left: 4px;
}

.el-textarea {
  margin-bottom: 2px;
}

.form-control {
  margin-bottom: 4px;
}

.input-group-text {
  background-color: #f1f1f1;
}
</style>
